import { LedStripVariantIcon } from './LedStripVariantIcon';

/**
 * author: Borre Haugen
 * id E4D78AC1-63FD-4BF0-89CD-91D80CCAAE40
 * name led-strip-variant
 * version: 4.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/led-strip-variant.svg
 * tags
 * - Home Automation 
 */
export const LightStripVariantIcon = LedStripVariantIcon;
export default LightStripVariantIcon